<template>
    <div class="fullBg animate__animated animate__bounceIn">
        <div class="leftInfoMsg">
            <!--            <img v-if="$route.params.injuryImg" :src="$route.params.injuryImg" alt="">-->
            <!--            <img v-else src="../assets/img/reportImg/bodyImg.png" alt="">-->
            <div class="infoMsgBox">
                <div class="headP">
                    <p class="img"><img
                        :src="injuryDetail?injuryDetail.avatar:require('@/assets/img/updateImg/playerHead.png')"
                        alt=""></p>
                    <p class="name"><span class="zh">{{ injuryDetail ? injuryDetail.name : '' }}</span><span class="en">{{
                            injuryDetail ? injuryDetail.nameEn : ''
                        }}</span>
                    </p>
                </div>
                <div class="bodyStateNo bodyState">
                    <p class="overText"><span class="label">伤病总数：</span> <span
                        class="val">{{ injuryDetail ? injuryDetail.injuryCount : '' }}</span>
                    </p>
                    <p><span class="label">受伤严重程度：</span><span
                        class="val">{{ injuryDetail ? injuryDetail.injurySeverityMax : '' }}</span></p>
                    <p><span class="label">是否随队训练：</span> <span
                        class="val">{{ injuryDetail ? injuryDetail.teamTraining ? '是' : '否' : '' }}</span>
                    </p>
                    <p><span class="label">预期恢复时间：</span><span
                        class="val">{{ injuryDetail ? injuryDetail.esimatedReturnDate : '' }}</span>
                    </p>
                </div>
            </div>
            <!--            <img class="body" src="../assets/img/reportImg/bodyImg3.png" alt="">-->
            <div class="body">
                <carousel :interval="3000" :arrow="'never'" height="100%" :indicator-position="'none'">
                    <carousel-item v-for="i in 3">
                        <img style="width: 100%" :src="require('@/assets/img/reportImg/injuryBody'+ i +'.png')" alt="">
                        <div class="myDrawing" :id="'Drawing' + i"></div>
                    </carousel-item>
                </carousel>
            </div>

        </div>
        <div class="rightBox">
            <p class="title">伤病信息</p>
            <div class="rightInjuryData" id="cardBg" @click="clearTimeFn">
                <div class="listItem">
                    <div class="item" v-for="(itemChild,indChild) in injuryListData">
                        <div v-if="itemChild.recordType=='treatment' && itemChild.recure==false"
                             :class="(indChild==0)?'warningBorder':'historyBorder'" class="injuryItem">
                                    <span
                                        class="dateBig">{{
                                            $global.formatDate(itemChild.createTime, 'yyyy/MM/dd')
                                        }}</span>
                            <div class="left">
                                <span class="imgBox"><img :src="itemChild.creatorAvatar" alt=""></span>
                                <span class="value">
                                            <span class="name">{{ itemChild.creatorName }}</span>
                                        </span>
                            </div>
                            <div class="middel"><span class="yuan"></span></div>
                            <div class="right">
                                <p class="tit">治疗</p>
                                <p class="label">
                                    <span>治疗方案：</span><span class="col">{{ itemChild.treatment }}</span>
                                </p>
                                <p class="label">
                                    <span>用药记录：</span><span class="col">{{ itemChild.medication }}</span>
                                </p>
                                <p class="label">
                                    <span>预期复出时间：</span><span class="col check">{{
                                        itemChild.esimatedReturnDate
                                    }}</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="itemChild.recordType=='recovery' && itemChild.recure==false"
                             class="injuryItem recoveryBorder">
                                    <span
                                        class="dateBig">{{
                                            $global.formatDate(itemChild.createTime, 'yyyy/MM/dd')
                                        }}</span>
                            <div class="left">
                                <span class="imgBox"><img :src="itemChild.creatorAvatar" alt=""></span>
                                <span class="value">
                                            <span class="name">{{ itemChild.creatorName }}</span>
                                        </span>
                            </div>
                            <div class="middel"><span class="yuan"></span></div>
                            <div class="right">
                                <p class="tit">恢复</p>
                                <p class="label">
                                            <span class="col">
                                <pre>{{ itemChild.remark }}</pre>
                                </span>
                                </p>
                            </div>
                        </div>
                        <div v-if="itemChild.recordType=='injury'" class="injuryItem errorBorder">
                                    <span
                                        class="dateBig">{{
                                            $global.formatDate(itemChild.createTime, 'yyyy/MM/dd')
                                        }}</span>
                            <div class="left">
                                <span class="imgBox"><img :src="itemChild.creatorAvatar" alt=""></span>
                                <span class="value">
                                            <span class="name">{{ itemChild.creatorName }}</span>
                                        </span>
                            </div>
                            <div class="middel"><span class="yuan"></span></div>
                            <div class="right">
                                <p class="tit">伤病</p>
                                <p class="label">
                                    <span>受伤日期：</span><span class="col">{{ itemChild.date }}</span>
                                </p>
                                <p class="label">
                                    <span>受伤位置：</span><span class="col">{{ itemChild.position }}</span>
                                </p>
                                <p class="label">
                                    <span>受伤原因：</span><span class="col">{{ itemChild.reason }}</span>
                                </p>
                                <p class="label">
                                    <span>随队训练：</span><span class="col">{{
                                        itemChild.teamTraining ? '是' : '否'
                                    }}</span>
                                </p>
                                <p class="label">
                                    <span>严重程度：</span><span class="col">{{ itemChild.severity }}</span>
                                </p>
                            </div>
                        </div>
                        <div v-if="itemChild.recure" class="injuryItem successBorder">
                                    <span
                                        class="dateBig">{{
                                            $global.formatDate(itemChild.createTime, 'yyyy/MM/dd')
                                        }}</span>
                            <div class="left">
                                <span class="imgBox"><img :src="itemChild.creatorAvatar" alt=""></span>
                                <span class="value">
                                            <span class="name">{{ itemChild.creatorName }}</span>
                                        </span>
                            </div>
                            <div class="middel"><span class="yuan"></span></div>
                            <div class="right">
                                <p class="tit">康复</p>
                                <p class="label">
                                    <span>康复时间：</span><span
                                    class="col updataDate">{{ itemChild.recureDate }}</span>
                                </p>
                                <p class="label">
                                    <span>预期复出时间:</span><span
                                    class="col">{{ itemChild.esimatedReturnDate }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery"
import photoCard from "../components/photoCard";


export default {
    name: "injuryDetail",
    components: {
        photoCard
    },
    computed: {},
    data() {
        return {
            injuryListData: [],//伤病历史
            scrollDomHeight: 0,//伤病占dom高度
            injuryDetail: null,//伤病人员基本信息
            animate: false,//滚动动画
            time: null,//定时器
            canvasHistory: [],//伤病canvas
            darwing: null,//伤病
            circleR: 15,
            lineWidth: 1,
            scrollTime: 0,//滚动时间
            height: 1,
        }
    },
    mounted() {
        this.info();
    },
    methods: {
        info() {
            let data = {
                playerId: this.$route.params.id
                // playerId: '60f5097d24df485358d8f730'
            }
            this.$server.injuryHistory(data)
                .then((res) => {
                    this.injuryListData = res.data;
                    let setTime = setTimeout(() => {
                        this.scroll();
                    }, 3000);
                })
            this.$server.injuryDetail(data)
                .then((res) => {
                    this.injuryDetail = res.data;
                    console.log(this.injuryDetail);
                    let injurySvg = this.injuryDetail.injurySvg;
                    let injurySvgArr = [];
                    let svg1 = []; // 第一张svg
                    let svg2 = []; // 第二张svg
                    let svg3 = []; // 第三张svg
                    for (let item in injurySvg) {
                        svg1.push(...injurySvg[item][0]);
                        svg2.push(...injurySvg[item][1]);
                        svg3.push(...injurySvg[item][2]);

                    }
                    injurySvgArr = [svg1, svg2, svg3];

                    // console.log(injurySvgArr)

                    $("svg").empty();
                    for (let i = 0; i < 3; i++) {
                        this.initSvg(injurySvgArr[i], '#Drawing' + (i+1));
                    }
                    this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + res.data.name + '的伤病详情'), true, false)
                })

        },
        //滚动数据
        scroll() {
            var hScrollTop = document.getElementById('cardBg').scrollTop;
            var hScrollHeight = document.getElementById('cardBg').scrollHeight;
            var offsetHeight = document.getElementById('cardBg').offsetHeight;

            // console.log(hScrollTop + " " + hScrollHeight + " " + this.height + ' ' + offsetHeight);
            if ((offsetHeight + hScrollTop) >= hScrollHeight) {//滚动条已经到了容器底部
                this.height = -1;
            }else if (hScrollTop === 0) {
                this.height = 1;
            }

            var h = hScrollTop + this.height;
            document.getElementById('cardBg').scrollTop = h;
            this.time = window.requestAnimationFrame(this.scroll)
        },
        clearTimeFn() {
            console.log('执行取消事件')
            window.cancelAnimationFrame(this.time)
            return false;
        },
        //获取后台svg，回显
        initSvg(data, domId) {
            console.log(data)
            console.log(domId)
            let that = this;
            let canvasHistory = [];
            let darwing = this.SVG().addTo(domId).size('100%', '100%');
            if (!data.length) return
            data.forEach((item) => {
                let svg = '';
                if (this.parseDom(item).childNodes[0].getAttribute('id').indexOf('Circle') > -1) {
                    //圆
                    let r = this.parseDom(item).childNodes[0].getAttribute('r');
                    let cx = this.parseDom(item).childNodes[0].getAttribute('cx');
                    let cy = this.parseDom(item).childNodes[0].getAttribute('cy');
                    let stroke = this.parseDom(item).childNodes[0].getAttribute('stroke');
                    let fill = this.parseDom(item).childNodes[0].getAttribute('fill');
                    // console.log( that.darwing);
                    // console.log(cx);
                    // console.log(cy);
                    if (cx > 1 && cy > 1) {
                        svg = darwing.circle(that.circleR)
                            .attr('stroke-width', that.lineWidth).attr("stroke", stroke).attr("fill", fill)
                            .attr({cx: cx, cy: cy});
                    } else {
                        svg = darwing.circle(that.circleR)
                            .attr('stroke-width', that.lineWidth).attr("stroke", stroke).attr("fill", fill)
                            .attr({cx: (cx * 100) + '%', cy: (cy * 100) + '%'});
                    }
                }
                let group = darwing.group();
                group.add(svg);
                canvasHistory.push(group);
            })
        },
        //string转dom
        parseDom(arg) {
            let objE = document.createElement("div");
            objE.innerHTML = arg;
            return objE.childNodes[0];
        }
    },
    beforeDestroy() {
        window.cancelAnimationFrame(this.time)
    }
}
</script>

<style scoped lang="less">
.fullBg {
    background-image: url("../assets/img/updateImg/bg1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.anim {
    transition: all 20s linear;
    /*margin-top: -30px;*/
}

.leftInfoMsg {
    width: calc(60% - 2vw);
    height: 100%;
    display: inline-block;
    position: relative;
    float: left;
    margin-left: 2vw;
    padding-top: 5vw;

    .infoMsgBox {
        width: 100%;

        .headP {
            border-bottom: 1px solid rgba(255, 255, 255, .03);
            margin-left: 3vw;
            font-size: 44px;
            margin-top: 3vw;
            height: 8vw;
            margin-bottom: 1vw;
            /*line-height: 8vw;*/
            background-size: auto 100%;
            background-repeat: no-repeat;

            .img {
                float: left;
                width: 7vw;
                height: 7vw;
                overflow: hidden;
                border-radius: 50%;
                background-color: rgba(12, 12, 13, 1);

                img {
                    width: 100%;
                }
            }

            .name {
                padding-left: 3vw;
                float: left;
                font-family: PingFangMedium;

                span {
                    display: block;
                }

                span.zh {
                    font-weight: bolder;
                    font-size: 60px;
                    background: linear-gradient(180deg, #FFFFFF 0%, #CAC9C9 200%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                span.en {
                    font-size: 30px;
                    background: linear-gradient(180deg, rgba(255, 255, 255, .6) 0%, rgba(202, 201, 201, .6) 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }
        }

        .bodyState {
            height: 6.5vw;
            width: 100%;
            box-sizing: border-box;
            font-size: 20px;
            float: left;
            text-align: left;
            padding-left: 4vw;

            p {
                line-height: 2.5vw;
                float: left;
                height: 2.5vw;
                display: inline-block;
                width: calc(50% - 4vw);
                background-image: url("../assets/img/updateImg/personalLittle.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
                background-position: left;
                margin-right: 4vw;
                margin-bottom: 1vw;
            }

            .label {
                color: rgba(255, 255, 255, .7);
                padding-left: 1.5vw;
                width: 9vw;
                display: inline-block;
            }

            .val {
                padding-left: 1vw;
                color: #E99AAA;
                /*font-size: 32px;*/
            }
        }

        .bodyStateYes {
            span.val {
                color: #0CB759 !important;

            }
        }
    }

}

.rightBox {
    width: 40%;
    height: 100%;
    float: left;
    padding-right: 2vw;
    /*padding-left: 3vw;*/
    box-sizing: border-box;
    display: inline-block;


    p.title {
        background-image: url("../assets/img/playerImg/titleBg.png");
        background-repeat: no-repeat;
        background-size: auto 100%;
        margin-top: 5vw;
        font-size: 30px;
        text-align: left;
        margin-bottom: 2vw;
        line-height: 3vw;
    }

    .rightInjuryData {
        width: 100%;
        height: calc(100% - 15vw);
        position: relative;
        overflow-y: auto;
        clear: both;
        font-family: PingFangMedium;

    }
}

.leftInfoMsg {
    /*text-align: center;*/
    padding-left: 1vw;
    box-sizing: border-box;

    .body {
        /*margin-top: 35%;*/
        width: 441px;
        height: 373px;
        left: 25%;
        bottom: 8vw;
        position: absolute;
        transform: scale(1.2);
    }

    .myDrawing {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }
}

//康复
.recoveryBorder.injuryItem {
    border-left: 1px #464646 dashed;

    .imgBox {
        border: 2px solid rgba(201, 206, 210, 0.46);
    }

    .right {
        em {
            border-color: transparent transparent rgba(252, 252, 252, 0.04) !important;
        }
    }

    .date {
        color: #fff;
    }

    .updataDate {
        color: #A5A5A5;
    }

    .middel {
        .yuan {
            border: 1px solid #A5A5A5;
            background: #0EBB9C;
        }
    }

    .label {
        .col {
            line-height: 2vw;
        }
    }

    .tit {
        color: #0EBB9C
    }
}

//历史伤病样式
.historyBorder.injuryItem {
    border-left: 1px #464646 dashed;

    .imgBox {
        border: 2px solid rgba(201, 206, 210, 0.46);
    }

    .right {
        em {
            border-color: transparent transparent rgba(252, 252, 252, 0.04) !important;
        }
    }

    .date {
        color: #fff;
    }

    .updataDate {
        color: #A5A5A5;
    }

    .middel {
        .yuan {
            border: 1px solid #A5A5A5;
            background: #1C1E1F
        }
    }
}

.warningBorder.injuryItem {
    border-left: 1px #504439 dashed;

    .imgBox {
        border: 2px solid #E4A76A;
    }

    .date, .updataDate {
        color: #E4A76A;
    }

    .middel {
        .yuan {
            border: 1px solid #E4A76A;
            background: #FEC557;
        }
    }

    .tit {
        color: #FEC557
    }

    .label {
        .col.check {
            color: #FEC557 !important;
        }
    }
}

.errorBorder.injuryItem {
    border-left: 1px #5B474A dashed;

    .date, .updataDate {
        color: #E99AAA !important;
    }

    .right {
        .label {
            line-height: 2vw;

            span.col {
                padding-left: 1vw;
                padding-right: 1.5vw;
            }
        }
    }

    .middel {
        .yuan {
            border: 1px solid #E99AAA;
            background: #DE6969;
        }
    }

    .imgBox {
        border: 2px solid #E99AAA;
    }

    .tit {
        color: #E99AAA
    }

    .label {
        .col {
            color: #E99AAA !important;
        }
    }
}

.successBorder.injuryItem {
    border-left: 1px #3F514B dashed;

    .date, .updataDate {
        color: #75D495 !important;
    }

    .label {
        padding-bottom: .3vw;

        .col {
            padding-left: 1vw;
            font-size: 22px;
        }
    }

    .middel {
        .yuan {
            border: 1px solid #75D495;
            background: #6ACB6E;
        }
    }

    .imgBox {
        border: 2px solid #75D495;
    }

    .tit {
        color: #75D495
    }

    .label {
        .col.check {
            color: #75D495 !important
        }
    }
}

.dateBig.history {
    color: #6E6967;
}

.dateBig.warning {
    color: #E4A76A;
}

.dateBig.error {
    color: #E99AAA;
}

.dateBig.success {
    color: #0CB759;
}

.rightInjuryData {
    .list:first-child .item:first-child .injuryItem .middel {
        top: 58px;
    }

    .list:first-child {

    }

    .list:first-child {
        .item:first-child {
            .dateBig {
                padding-top: 60px;
            }

            .injuryItem {
                padding-top: 55px;
            }
        }


    }

    .listItem {
        width: 80%;
        float: left;

    }

    .injuryItem {
        text-align: left;
        color: #fff;
        width: 100%;
        float: left;
        padding-left: .5vw;
        box-sizing: border-box;
        padding-bottom: 2vw;
        position: relative;
        margin-left: 9vw;

        .left, .right {
            /*float: left;*/
        }

        .left {
            /*width: 7vw;*/
            /*text-align: center;*/
            padding-left: 1.5vw;

            .value {
                float: left;
            }

            .dateSmall, .name {
                line-height: 20px;
                display: block;
                padding-left: 1vw;
            }

            .name {
                margin-top: .5vw;
                font-size: 22px;
                padding-bottom: .5vw;
            }
        }

        .right {
            width: 100%;
            box-sizing: border-box;
            padding: 0 1vw 1vw;
            font-size: 20px;
            line-height: 24px;
            position: relative;
            clear: both;

            em {
                display: block;
                width: 0;
                height: 0;
                border-width: 0 10px 10px;
                border-style: solid;
                position: absolute;
                top: 1px;
                left: -10px;
                border-color: transparent transparent #0F0F0F;
            }

            .tit {
                padding-top: 1vw;
                padding-bottom: .3vw;
                font-size: 24px;
            }

            .cont {
                margin-top: .3vw;
                color: rgba(255, 255, 255, .7);
                line-height: 30px;
            }

            .updataDate {
                margin-top: .3vw;
                font-size: 22px;
            }

            .label {
                color: rgba(255, 255, 255, .6);

                .col {
                    line-height: 2vw;
                    color: rgba(255, 255, 255, .8);
                }
            }
        }

        .middel {
            position: absolute;
            left: -15px;
            top: 0;
            width: 30px;
            height: 40px;
            text-align: center;
            z-index: 1000;
            //background: #0F0F0F;
            line-height: 40px;
            padding-top: .2vw;

            .yuan {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                display: inline-block;
            }
        }

        .imgBox {
            display: inline-block;
            width: 3vw;
            height: 3vw;
            overflow: hidden;
            border-radius: 50%;
            float: left;

            img {
                width: 100%;
            }
        }

        .date {
            font-size: 20px;
            margin-right: .5vw;
        }

        .time {
            font-size: 20px;
            color: rgba(241, 241, 241, .4);
            font-family: PingFangMedium;
        }
    }

    .dateBig {
        width: 10vw;
        /*float: left;*/
        /*text-align: right;*/
        padding-right: 2vw;
        box-sizing: border-box;
        line-height: 35px;
        font-size: 24px;
        position: absolute;
        left: -9vw;
        top: 0;
        font-family: PingFangMedium;
    }
}

::v-deep .el-carousel {
    height: 100%;
}
</style>
